/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useState, useCallback, useMemo } from "react";
import { OrderModel } from "../Utils/Models";

export const OrderContext = createContext<{
  order: OrderModel;
  setOrder: (order: OrderModel) => void;
}>({
  order: new OrderModel(),
  setOrder: () => {},
});

export const OrderContextProvider = (props: any) => {
  const [order, setOrderState] = useState<OrderModel>(new OrderModel());

  const setOrder = useCallback((newOrder: OrderModel) => {
    setOrderState(newOrder);
  }, []);

  const contextValue = useMemo(() => ({
    order,
    setOrder,
  }), [order, setOrder]);

  return (
    <OrderContext.Provider value={contextValue}>
      {props.children}
    </OrderContext.Provider>
  );
};
